import * as yup from "yup";
import { NATIONAL_ID_PATTERN, splitRepresentativeName } from "../representative";
import type { Translator } from "./validationHelpers";

export interface RepresentativeValidationMessages {
  required: string;
  surnameRequired: string;
  nationalIdInvalid: string;
  emailInvalid: string;
}

export function createRepresentativeValidationMessages(
  t: Translator,
): RepresentativeValidationMessages {
  return {
    required: t("validation.required"),
    surnameRequired: t("validation.surname_required"),
    nationalIdInvalid: t("validation.national_id_invalid"),
    emailInvalid: t("validation.email_invalid"),
  };
}

export function createRepresentativeSchema(msgs: RepresentativeValidationMessages) {
  return yup.object({
    fullName: yup
      .string()
      .defined()
      .default("")
      .trim()
      .required(msgs.required)
      .test(
        "surname",
        msgs.surnameRequired,
        (value) => splitRepresentativeName(value ?? "").lastName !== "",
      ),
    dni: yup
      .string()
      .defined()
      .default("")
      .trim()
      .required(msgs.required)
      .matches(NATIONAL_ID_PATTERN, msgs.nationalIdInvalid),
    position: yup.string().defined().default("").required(msgs.required),
    phone: yup.string().defined().default(""),
    email: yup.string().defined().default("").trim().email(msgs.emailInvalid),
  });
}

export function createOptionalRepresentativeSchema() {
  return yup.object({
    fullName: yup.string().defined().default(""),
    dni: yup.string().defined().default(""),
    position: yup.string().defined().default(""),
    phone: yup.string().defined().default(""),
    email: yup.string().defined().default(""),
  });
}

export function createRepresentativeFormSchema(msgs: RepresentativeValidationMessages) {
  return yup.object({ representative: createRepresentativeSchema(msgs) });
}

export type RepresentativeFormData = yup.InferType<
  ReturnType<typeof createRepresentativeFormSchema>
>;

export const EMPTY_REPRESENTATIVE: RepresentativeFormData["representative"] = {
  fullName: "",
  dni: "",
  position: "",
  phone: "",
  email: "",
};
